import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import config from './config.js'
import { Clerk } from '@clerk/clerk-js'

// Initialize Clerk
const clerk = new Clerk(config.clerk.publishableKey)

// Make clerk available globally
Vue.prototype.$clerk = clerk

// Add $auth alias for backward compatibility with existing components
Vue.prototype.$auth = {
  getAccessToken: async () => clerk.session?.getToken()
}

// Setup axios
axios.defaults.baseURL = config.baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json'

// Add axios interceptor to include Clerk token in requests
axios.interceptors.request.use(async (axiosConfig) => {
  if (clerk.session) {
    const token = await clerk.session.getToken()
    if (token) {
      axiosConfig.headers.Authorization = `Bearer ${token}`
    }
  }
  return axiosConfig
}, (error) => {
  return Promise.reject(error)
})

// Add response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect to login on unauthorized
      router.push({ name: 'login' })
    }
    return Promise.reject(error)
  }
)

// Initialize Clerk and mount Vue app
clerk.load().then(() => {
  new Vue({
    el: '#app',
    router,
    vuetify,
    render: h => h(App)
  })
})
